import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './GuildWar.css';

const GuildWar = () => {
  const [season, setSeason] = useState(0);
  const [opponent, setOpponent] = useState('opponent');
  const [match, setMatch] = useState(1);
  const [tower, setTower] = useState(1);
  const [guildName, setGuildName] = useState('');
  const [defenders, setDefenders] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const getStartOfWeek = (season) => {
    const today = new Date();
    const newDate = new Date(today.getTime());
    const offset = season * 7;
    newDate.setDate(newDate.getDate() - offset);
    return newDate.toISOString().split('T')[0];
  };

  const fetchGuildWarData = async () => {
    setIsLoading(true);
    try {
      setIsError(false);
      const requestDate = getStartOfWeek(season);
      const response = await axios.get(
        'https://rangers-api-3mfw.onrender.com/api/consolelog',
        {
          params: {
            guild: "Nihon",
          },
        }
      );

      const data = response.data;
    } catch (error) {
      setIsError(true);
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchGuildWarData();
  }, [season, opponent, match, tower]);

  const getSwitchText = (equipMap) => {
    if (!equipMap.attr4No) {
      return '';
    }
    if (typeof equipMap.attr4No !== 'string') {
      equipMap.attr4No = String(equipMap.attr4No);
    }
    const prefix = equipMap.attr4No.substring(0, 2);
    const suffix = equipMap.attr4No.substring(4, 6);

    const switchTexts11 = {
      '01': '物攻',
      '02': '命中',
      '03': 'ス発',
      '04': 'ス命',
      '05': '攻ス',
      '06': '体力',
      '07': '回避',
      '08': 'ス回',
      '09': 'ス抵',
      '10': '物反',
      '11': '魔反',
      '12': 'ﾉｯｸ',
      '13': 'ｽﾀﾝ',
      '14': '沈黙',
      '15': '移動',
      '16': '攻範',
      '17': 'ミネ',
      '18': '再出',
    };

    const switchTexts12 = {
      '01': '物攻',
      '02': '命中',
      '03': '決確',
      '04': '決ダ',
      '05': 'ス発',
      '06': 'ス命',
      '07': '攻ス',
      '08': '体力',
      '09': '回避',
      '10': 'ス回',
      '11': 'ス抵',
      '12': 'ﾉｯｸ',
      '13': 'ｽﾀﾝ',
      '14': '沈黙',
      '15': '移動',
      '16': '攻範',
      '17': 'ミネ',
      '18': '再出',
    };

    const switchTexts13 = {
      '01': '魔攻',
      '02': '命中',
      '03': 'ス発',
      '04': 'ス命',
      '05': '攻ス',
      '06': '物防',
      '07': '魔防',
      '08': '体力',
      '09': '回避',
      '10': 'ス回',
      '11': 'ス抵',
      '12': 'ﾉｯｸ',
      '13': 'ｽﾀﾝ',
      '14': '沈黙',
      '15': '移動',
      '16': '攻範',
      '17': 'ミネ',
      '18': '再出',
    };

    const switchTexts14to18 = {
      '01': '物攻',
      '02': '魔攻',
      '03': '命中',
      '04': 'ス発',
      '05': 'ス命',
      '06': '攻ス',
      '07': '体力',
      '08': '回避',
      '09': 'ス回',
      '10': 'ス抵',
      '11': 'ﾉｯｸ',
      '12': 'ｽﾀﾝ',
      '13': '沈黙',
      '14': '移動',
      '15': '攻範',
      '16': 'ミネ',
      '17': '再出',
      '18': '属強',
      '19': '属命',
    };

    let switchText = '';
    if (prefix === '11') {
      switchText = switchTexts11[suffix];
    } else if (prefix === '12') {
      switchText = switchTexts12[suffix];
    } else if (prefix === '13') {
      switchText = switchTexts13[suffix];
    } else if (
      prefix === '14' ||
      prefix === '15' ||
      prefix === '16' ||
      prefix === '17' ||
      prefix === '18'
    ) {
      switchText = switchTexts14to18[suffix];
    }

    return switchText ? switchText + (equipMap.currentAdvancedEnchant ?? '?') : '不明';
  };

  const selectGroup = (
    <div className="select-group">
      <h1>にほーん</h1>
      <div>
        <label>Season:</label>
        <select
          onChange={(e) => setSeason(parseInt(e.target.value, 10))}
          value={season}
        >
          <option value="0">今週</option>
          <option value="1">1週前</option>
          <option value="2">2週前</option>
          <option value="3">3週前</option>
          <option value="4">4週前</option>
          <option value="5">5週前</option>
          <option value="6">6週前</option>
          <option value="7">7週前</option>
          <option value="8">8週前</option>
          <option value="9">9週前</option>
          <option value="10">10週前</option>
          <option value="11">11週前</option>
          <option value="12">12週前</option>
          <option value="13">13週前</option>
          <option value="14">14週前</option>
          <option value="15">15週前</option>
          <option value="16">16週前</option>
          <option value="17">17週前</option>
          <option value="18">18週前</option>
          <option value="19">19週前</option>
          <option value="20">20週前</option>
        </select>
      </div>

      <div>
        <label>Opponent:</label>
        <select
          onChange={(e) => setOpponent(e.target.value)}
          value={opponent}
        >
          <option value="ally">味方</option>
          <option value="opponent">敵</option>
        </select>
      </div>

      <div>
        <label>Match:</label>
        <select
          onChange={(e) => setMatch(parseInt(e.target.value, 10))}
          value={match}
        >
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
        </select>
      </div>

      <div>
        <label>Tower:</label>
        <select
          onChange={(e) => setTower(parseInt(e.target.value, 10))}
          value={tower}
        >
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option>
          <option value="7">7</option>
          <option value="8">8</option>
          <option value="9">9</option>
          <option value="10">10</option>
        </select>
      </div>
      <br />
    </div>
  );

  return (
    <div className="guild-war-container">
      {selectGroup} {/* 選択部分は常に表示 */}

      {isError ? (
        <p>データの取得中にエラーが発生しました。後でもう一度お試しください。</p>
      ) : isLoading ? (
        <p>データ読み込み中...(数分ほどかかる場合があります)</p>
      ) : (
        <>
        </>
      )}
    </div>
  );
};

export default GuildWar;
